import { SizableText, Paragraph, YStack, Button } from '@my/ui'
import { ChevronDown, ChevronUp } from '@tamagui/lucide-icons'
import { useState } from 'react'

export const GroupCardDescription = ({ description }) => {
  const canExpand = description.length > 150
  const [expanded, setExpanded] = useState(false)
  const toggleExpanded = () => setExpanded((prev) => !prev)

  return (
    <YStack w="100%" ai="flex-start" gap="$2">
      <SizableText
        size="$4"
        fow="600"
        $gtSm={{
          size: '$6',
          fow: '600',
        }}
      >
        About this group
      </SizableText>
      <Paragraph
        color="$overlay10"
        size="$3"
        $gtSm={{ size: '$4' }}
        {...(!expanded && {
          numberOfLines: 4,
        })}
      >
        {description}
      </Paragraph>
      {canExpand && (
        <Button
          w="100%"
          plain
          onPress={toggleExpanded}
          fontWeight="500"
          iconAfter={expanded ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </YStack>
  )
}
